import { bindable, BindingMode, inject, IEventAggregator } from 'aurelia';
import { getLogger } from '../../common/logging';
import { CurrentRoute } from '../../current-route';
import { ApplicationLinkChanged } from '../../messages/application-link-changed'
import { ApplicationLinksService } from '../../services/application-links-service';

let log = getLogger('application-link');

@inject(Element, CurrentRoute, IEventAggregator, ApplicationLinksService)
export class ApplicationLinkCustomElement {
  @bindable({ mode: BindingMode.twoWay }) value;
  @bindable placeholder;
  @bindable tabindex;
  @bindable({ mode: BindingMode.twoWay }) linkName;
  @bindable description;

  constructor(element, currentRoute, ea, svc) {
    this.element = element;
    this.currentRoute = currentRoute;
    this.svc = svc;
    this.ea = ea;
    this.timeout = new Timeout();
    this.timeout.clear();
  }

  attached() {
    if (!this.placeholder) this.placeholder = '';
    this.referenceId = this.currentRoute.params.id;
    this.isAttached = true;
    this.svc.get(this.referenceId, this.linkName).then(res => {
      if (!res) return;
      this.ea.publish(new ApplicationLinkChanged(res.id, this.linkName));
    });
  }

  detaching() {
    this.isAttached = false;
  }

  valueChanged(newValue, oldValue) {
    if (!this.isAttached) return
    if (newValue === oldValue) return;
    this.value = newValue;
    this.timeout.clear();
    let url = newValue;
    this.timeout.set(() => {
      if(url){
        if (!url.startsWith('http://')) {
          if (!url.startsWith('https://')) {
            url = url.padStart(url.length + 8, 'https://');
            this.value = url;
          }
        }
      }

      this.svc.save(this.referenceId, this.linkName, url, this.description).then(res => {
        this.ea.publish(new ApplicationLinkChanged(res.id, this.linkName))
      });
    }, 500)
  }
}

class Timeout {
  contstructor() {
    this.current = 0;
  }

  set(callback, timeout) {
    this.current = setTimeout(callback, timeout);
  }

  clear() {
    clearTimeout(this.current);
    this.current = 0;
  }
}
